<template>
    <DataTable
            ref="dataTable"
            v-redirect-if-no-permission:VOUCHERS
            :title="$t('settings.vouchersList.title')"
            :url="api.ACTIONS.VOUCHERS"
            :fields-hidden-main='["deleted_at","updated_at","is_public","type","amount","specific_location_whitelist","specific_location_blacklist","specific_service","use_times","customer_limits"]'
            :actions-extra-main="actionsExtraMain"
            :formatter="formatter"
            :titles="titles"
            :conditional-action="conditionalAction"
            :enable-edit="false"/>
</template>

<script>
    import DataTable from '@/components/monaco/DataTable';

    export default {
        name: "VouchersList",
        title() {
            return this.$t('settings.vouchersList.title');
        },
        components: {DataTable},
        computed: {
            conditionalAction() {
                return {
                    delete({deleted_at}) {
                        return !deleted_at;
                    },
                    restore({deleted_at}) {
                        return !!deleted_at;
                    },
                    edit({deleted_at}) {
                        return !deleted_at;
                    }
                }
            },
            titles() {
                return {
                    "id": "#",
                    "code": this.$t("settings.vouchersList.code"),
                    "title": this.$t("settings.vouchersList.titleColumn"),
                    "Details": this.$t("settings.vouchersList.details"),
                    "use_times": this.$t("settings.vouchersList.usageTimes"),
                    "is_public": this.$t("settings.vouchersList.public"),
                    "type": this.$t("settings.vouchersList.type"),
                    "amount": this.$t("settings.vouchersList.amount"),
                    'start_date': this.$t("settings.vouchersList.startDate"),
                    "end_date": this.$t("settings.vouchersList.endDate"),
                    "start_time": this.$t("settings.vouchersList.startTime"),
                    "end_time": this.$t("settings.vouchersList.endTime"),
                    "created_at": this.$t("settings.vouchersList.createdAt"),
                    "slice": this.$t("settings.vouchersList.slice")
                }
            },
            actionsExtraMain() {
                return {
                    restore: {
                        title: this.$t("settings.vouchersList.restore"),
                        icon: "restore",
                        extras: {
                            color: "primary"
                        },
                        action: async (item) => this.$refs.dataTable.action(item, 'delete')
                    },
                    add: {
                        link: '/vouchers/add'
                    },
                    edit: {
                        title: this.$t("common.edit"),
                        icon: "edit",
                        extras: {
                            color: "secondary",
                        },
                        action: async (item) =>
                            this.$router.push({
                                name: 'VoucherDetails',
                                params: item
                            })
                    }
                };
            },
            formatter() {
                const noStartTime = this.$t("settings.vouchersList.noStartTime");
                const noEndTime = this.$t("settings.vouchersList.noEndTime");
                const noLimit = this.$t("settings.vouchersList.noLimit");
                return {
                    start_date(value) {
                        return (new Date(value)).toDateString()
                    },
                    end_date(value) {
                        return (new Date(value)).toDateString()
                    },
                    start_time(value) {
                        return value ? (new Date(value)).toTimeString() : noStartTime;
                    },
                    end_time(value) {
                        return value ? (new Date(value)).toTimeString() : noEndTime;
                    },
                    created_at(value) {
                        return (new Date(value)).toDateString();
                    },
                    customers_limit(value) {
                        return value || noLimit;
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>